import React, { useEffect, useState } from "react";
import { Button, Form } from "antd";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import AddBanner from "../AddBanner/AddBanner";
import { useBannerActions } from "../AddBanner/hooks/useBannerActions";

const EditBanner = () => {
  const history = useHistory();
  const location = useLocation();
  const { banner: initialBanner } = location.state || {};

  const [banner, setBanner] = useState(initialBanner || {});

  useEffect(() => {
    if (initialBanner) {
      setBanner(initialBanner);
    }
  }, [initialBanner]);

  const handleCancel = () => {
    history.push("/admin/banners");
  };
  return <AddBanner handleCancel={handleCancel} banner={banner} />;
};

export default EditBanner;
